module.exports = __webpack_public_path__ + "img/mobileBanner2.b761dade.png";